import type { HttpClient } from '@shared/http/http-client';
import type {
  IInvoiceRepository,
  InvoiceListQuery,
} from '@domain/data-contracts/invoice-repository.interface';
import type { Invoice } from '@domain/models/invoice.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapInvoiceDto,
  mapPaged,
  type InvoiceDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/invoices';

export class InvoiceRepository implements IInvoiceRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: InvoiceListQuery): Promise<PagedResult<Invoice>> {
    const response = await this.http.get<PagedDto<InvoiceDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapInvoiceDto);
  }
}

function pruneParams(query: InvoiceListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.status) { out.status = query.status; }
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
